(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const body = document.getElementById('collection-seo-body');
    const toggle = document.getElementById('collection-seo-toggle');
    const COLLAPSED_HEIGHT = '8.125rem';
    const COLLAPSIBLE_CLASS = 'collection-seo__body--collapsible';

    if (!body || !toggle) {
        return;
    }

    function isExpanded() {
        return body.getAttribute('aria-expanded') === 'true';
    }

    function setExpandedState(expanded) {
        body.setAttribute('aria-expanded', String(expanded));
        toggle.setAttribute('aria-expanded', String(expanded));
    }

    function updateCollapsibility() {
        const collapsedHeight = parseFloat(getComputedStyle(body).maxHeight);
        const isCollapsible = body.scrollHeight - collapsedHeight > 1;

        body.classList.toggle(COLLAPSIBLE_CLASS, isCollapsible);

        if (!isCollapsible) {
            body.style.maxHeight = 'none';
            setExpandedState(true);
            toggle.hidden = true;
            return;
        }

        toggle.hidden = false;

        if (!isExpanded()) {
            body.style.maxHeight = COLLAPSED_HEIGHT;
        }
    }

    toggle.addEventListener('click', function () {
        const expanded = isExpanded();

        if (expanded) {
            // Start from the current rendered height, then animate to collapsed height
            body.style.maxHeight = body.getBoundingClientRect().height + 'px';
            void body.offsetHeight;
            body.style.maxHeight = COLLAPSED_HEIGHT;
            setExpandedState(false);
        } else {
            // Start from current state and animate to full content height
            body.style.maxHeight = body.scrollHeight + 'px';
            setExpandedState(true);
        }
    });

    body.addEventListener('transitionend', function (event) {
        if (event.target !== body || event.propertyName !== 'max-height') {
            return;
        }

        if (isExpanded()) {
            body.style.maxHeight = 'none';
        }
    });

    requestAnimationFrame(updateCollapsibility);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-guide"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', () => {
		const triggers = document.querySelectorAll('.style-guide a[href]');
		const contents = document.querySelectorAll('.style-guide div[id]');

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();

				const id = trigger.getAttribute('href').replace('#', '');

				triggers.forEach((trigger) => trigger.classList.remove('active'));
				trigger.classList.add('active');

				contents.forEach((content) => {
					if (!content.classList.contains('hidden')) content.classList.add('hidden');
					if (content.id === id) content.classList.remove('hidden');
				});
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
